import { FC } from 'react';
import { RuleLine } from '@marriott/mi-ui-library';
import { InventoryInfoProps } from './InventoryInfo.types';
import { StyledInventoryInfo } from './InventoryInfo.styles';

export const InventoryInfo: FC<InventoryInfoProps> = ({ heading, description, startDate, endDate }) => {
  return (
    <StyledInventoryInfo>
      <h2 className="t-subtitle-m">{heading}</h2>

      <div className="inventory-content">
        <div className="t-font-s">{description}</div>
        <div className="date-section">
          <span className="icon-stay-dates"></span>
          <span className="t-font-s">
            {startDate} - {endDate}
          </span>
        </div>
      </div>

      <div className="mt-2">
        <RuleLine styleclass="ruler-length-100" />
      </div>
    </StyledInventoryInfo>
  );
};
